export default "__VITE_PUBLIC_ASSET__9af7ed8d__"